// types/configuration.ts


export interface ActionFlowConfigurationDTO {
    id: string;
    workflowId: string;
    name: string;
    description: string;
    version: string;
    configurationJson: string;
}

export interface ConfigurationFilter {
    name?: string;
    version?: string;
    description?: string;
}


export interface RequiredField {
    field: string;
    type: 'MAKER_FIELD' | 'CUSTOM';
    description: string;
    required: boolean;
}

export interface ApprovalConfig {
    minApprovals: number;
    totalApprovals: number;
}


export interface Position {
    x: number;
    y: number;
}


export enum ConfigurationStatus {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED'
}